module.exports = {
	gtmId: "GTM-WM4SJ4G",
	image_logoFavicon: "Icon-Mid-West.png",
	image_backgroundCompare: "our-process.jpg",
	image_backgroundTestimonial: "testimonial.jpg",
	image_backgroundStep2: "step2.png",
	image_backgroundHero: 'shutterstock_1171819066-for-yembo.png',
	image_logo: "Logo-MidwestMoving-transparent-trademark.png",
	image_logoFooter: "Icon-Mid-West.png",
	reviewsUrl: "https://www.midwestmoving.com/reviews/",
	headerTitle: "A Quick and Accurate Moving Quote!",
	altCtaLine2: "888.722.MOVE (6683)",
	altCtaPhoneE164: "+18887226683",
	highlightSubtitle2: "You always get an itemized quote based on your exact inventory.",
	reviewQuote: "My experience with Mid-West Moving & Storage was top notch. Great customer service, and the crew who moved my stuff were friendly, competent and FAST. I would work with Mid-West Moving again in a heartbeat!",
	reviewCaption: "- Tash S.",
	reviewStarsNumber: "5",
	certifications: "U.S. DOT #294025 | ILL. C.C. 75043",
	companyLegalName: "Mid-West Moving & Storage, Inc.",
	showLogoDropshadow: true,
}